import React, {useEffect, useState} from 'react';
import RepairEditorRepair from './RepairEditorRepair';
import Forms from "./Forms";
import {useTranslation} from "react-i18next";

const DEFAULT_REPAIR_ROW = {device: '', repairList: [], partsUsed: []};

const RepairEditor = ({
    deviceList,
    onRepairDataChange,
    initialRepairs = [],
    disableDeviceSelection = false,
    hideAddRepairButton = false,
    disableRemoveRepair = false
}) => {
    const {t} = useTranslation();
    const [repairs, setRepairs] = useState([DEFAULT_REPAIR_ROW]);

    useEffect(() => {
        if (initialRepairs?.length) {
            setRepairs(initialRepairs);
            onRepairDataChange(initialRepairs);
            return;
        }
        setRepairs([DEFAULT_REPAIR_ROW]);
        onRepairDataChange([DEFAULT_REPAIR_ROW]);
    }, [initialRepairs, onRepairDataChange]);

    const handleAddRepair = () => {
        setRepairs([...repairs, {device: null, repairList: [], partsUsed: []}]);
    };

    const handleRepairChange = (index, repairData) => {
        const updatedRepairs = [...repairs];
        updatedRepairs[index] = {...updatedRepairs[index], ...repairData};
        setRepairs(updatedRepairs);
        onRepairDataChange(updatedRepairs);
    };

    const handlePartsChange = (index, partsUsed) => {
        const updatedRepairs = [...repairs];
        updatedRepairs[index].partsUsed = partsUsed;
        setRepairs(updatedRepairs);
        onRepairDataChange(updatedRepairs);
    };

    const onRemoveRepair = (index) => {
        if (disableRemoveRepair) {
            return;
        }
        setRepairs(oldState => {
            const next = oldState.filter((_, i) => index !== i);
            onRepairDataChange(next);
            return next;
        });
    }

    return (
        <div>
            {repairs.map((repair, index) => (
                <RepairEditorRepair
                    selectedDevices={repairs.map(rep => rep.device).filter(i => i && i)}
                    key={index}
                    deviceList={deviceList}
                    repairData={repair}
                    onRepairChange={(repairData) => handleRepairChange(index, repairData)}
                    onPartsChange={(partsUsed) => handlePartsChange(index, partsUsed)}
                    onRemoveRepair={() => onRemoveRepair(index)}
                    disableDeviceSelection={disableDeviceSelection}
                    hideRemoveRepair={disableRemoveRepair}
                />
            ))}
            {!hideAddRepairButton && (
                <Forms.Button type="button" onClick={handleAddRepair} label={t('RepairEditor.addRepair')} className="mt-4"/>
            )}
        </div>
    );
};

export default RepairEditor;
